import { render, staticRenderFns } from "./institution-form.vue?vue&type=template&id=62f64ec8&scoped=true&lang=pug&"
import script from "./institution-form.vue?vue&type=script&lang=ts&"
export * from "./institution-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f64ec8",
  null
  
)

export default component.exports